import { useQuery } from '@tanstack/react-query';

import { getGivingHistory } from '@sola/proxy-sdk/utils/routes.js';

import { QUERY_KEYS } from '../constants';
import { useReadyForQueries } from './base';

/**
 * Hook to fetch giving history.
 *
 * TODO Mocks
 */
export const useGivingHistory = (year: string | number) => {
  const { isReady, globalId } = useReadyForQueries();
  return useQuery({
    queryKey: [QUERY_KEYS.supporterGivingHistory, year],
    queryFn: ({ queryKey }) => {
      const [, queryYear] = queryKey;
      return getGivingHistory(globalId!, {
        start: `${queryYear}-01-01`,
        end: `${queryYear}-12-31`,
      });
    },
    refetchOnWindowFocus: false,
    enabled: isReady,
    staleTime: Infinity,
  });
};
